import Observer from '@/src/utils/browser/intersectionObserver';
import PropTypes from 'prop-types';
import React from 'react';
import RenderGenericChildren from '../RenderGenericChildren';

const DEFAULT_TRESHOLD_MARGIN = '150px';

class IntersectionObserver extends React.Component {
  ref = React.createRef();

  componentDidMount() {
    const { callback, onInAndOut, threshold, thresholdMargin } = this.props;
    this.observer = new Observer(callback, {
      onInAndOut,
      threshold,
      thresholdMargin,
    });
    this.observer.observe(this.ref.current);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  render() {
    const { children, style } = this.props;
    return (
      <div ref={this.ref} style={style}>
        <RenderGenericChildren>{children}</RenderGenericChildren>
      </div>
    );
  }
}

IntersectionObserver.propTypes = {
  thresholdMargin: PropTypes.string,
  onInAndOut: PropTypes.bool,
  threshold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  style: PropTypes.object,
  callback: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

IntersectionObserver.defaultProps = {
  thresholdMargin: DEFAULT_TRESHOLD_MARGIN,
};

export default IntersectionObserver;
